import { Controller } from '@hotwired/stimulus'
import { jsPDF } from 'jspdf'

// Connects to data-controller="pdf"
export default class extends Controller {
  static targets = ['body']

  declare readonly bodyTarget: HTMLElement

  static values = {
    filename: String,
  }

  declare filenameValue: string

  // Warning: jdPDF is a bit scuffed when rendering HTML. These values work
  // well for the current layout, but may need to be adjusted if the layout changes.
  createPdf (): void {
    // eslint-disable-next-line new-cap
    const pdf = new jsPDF({
      orientation: 'p',
      unit: 'mm',
      format: 'letter',
      putOnlyUsedFonts: true,
      compress: true,
    })
    pdf.html(
      this.bodyTarget,
      {
        callback: (doc) => {
          doc.save(`${this.filenameValue}.pdf`)
        },
        margin: [15, 15, 15, 15],
        width: 180,
        windowWidth: 1080,
        autoPaging: 'text',
        html2canvas: {
          async: true,
          letterRendering: false,
          removeContainer: true,
        },
      }
    )
  }
}
